import { render } from "./Zonas.vue?vue&type=template&id=4ad599fe"
import script from "./Zonas.vue?vue&type=script&lang=js"
export * from "./Zonas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__